var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-messages" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("form-alerts", { attrs: { pageData: _vm.pageData } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "required row mx-0" }, [
      _c("div", { staticClass: "col-12 px-0 text-left" }, [
        _c("span", { staticClass: "star" }, [_vm._v("*")]),
        _vm._v("Required to calculate final rate.\n      "),
        _c("hr")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-095cba34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095cba34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/alerts/FormNotifications.vue
// module id = null
// module chunks = 